<template>
  <div>
    <div class="html2pdf__page-break member-card mx-auto">
      <div class="member-card-header d-flex justify-content-end">
        <img
          :src="memberCard.logoCompany"
          width="130"
          alt="morgan"
        >
      </div>
      <div
        class="member-card-content px-4 py-3"
        style="background-color: #1d82c4"
      >
        <div class="d-flex justify-content-between">
          <div
            class="text-light"
            style="flex: 2"
          >
            <div>Insured person:</div>
            <div>Policy number:</div>
            <div>Product name:</div>
            <div>Level:</div>
            <br>
            <div>Valid from:</div>
            <div>Excess/Deductible:</div>
          </div>
          <div style="flex: 1" />
          <div style="flex: 5">
            <div>{{ titleFullName }}</div>
            <div>{{ policyNumber }}</div>
            <div>{{ productName }}</div>
            <div>{{ levelCoverName }}</div>
            <br>
            <div>
              <span>{{ validFrom }}</span>
              <span class="ms-5">
                <span class="text-light">To:</span>
                <span class="ms-2">{{ validTo }}</span>
              </span>
            </div>
            <div>{{ excessWithSymbol }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="html2pdf__page-break member-card mx-auto">
      <div class="member-card-header d-flex justify-content-between px-2">
        <div>
          <!-- <span class="me-2">{{ residentCountryName }}</span> -->
          <img
            v-show="isShowLogo()"
            :src="memberCard.logo"
            width="80"
            alt="morgan"
          >
        </div>
        <div class="member-card-domain">
          {{ memberCard.domain }}
        </div>
      </div>
      <div
        class="member-card-content px-4 position-relative"
        :class="isShowByTaxCountry() ? 'py-2' : 'py-3'"
        style="background-color: #1d82c4"
      >
        <p
          v-if="isShowByTaxCountry()"
          style="font-size: 7pt; font-weight: 400; margin-bottom: 6px"
        >
          To access our cashless network, when you attend one of the clinics on the list we have provided, please ensure
          you show them this membership card with this logo.
        </p>
        <p style="margin-bottom: 3px">
          For emergency assistance and all claims queries please contact us on:
        </p>
        <div class="d-flex justify-content-start">
          <div class="me-5">
            <div>MP Claims:</div>
            <div>MP Email:</div>
          </div>
          <div>
            <div>+44(0) 3300 581 668</div>
            <div>{{ memberCard.emailContact }}</div>
          </div>
        </div>
        <div
          class="position-absolute bottom-0 mx-auto mb-1"
          style="font-size: 7pt; font-weight: 400; color: white"
        >
          The issue of this card is not an automatic guarantee of payment
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseApi from '../../api/common/baseApi.js'
import { CountryIncludeLogo } from '../../api/common/config'

export default {
  name: 'CardForm',
  components: {},
  props: {
    cardFormData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      titleFullName: this.cardFormData.titleFullName,
      policyNumber: this.cardFormData.policyNumber,
      productName: this.cardFormData.productName,
      levelCoverName: this.cardFormData.levelCoverName,
      validFrom: this.cardFormData.validFrom,
      validTo: this.cardFormData.validTo,
      excessWithSymbol: this.cardFormData.excessWithSymbol,
      residentCountryName: this.cardFormData.residentCountryName,

      memberCard: {
        logo: '',
        logoCompany: '',
        emailContact: '',
        domain: '',
      },

      countryIncludeLogo: CountryIncludeLogo,
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getMemberCardInformation()
  },
  methods: {
    isEuroEmail() {
      return this.residentCountryName === 'Germany'
    },

    isShowByTaxCountry() {
      let result = this.residentCountryName === 'Cyprus'
      return result
    },

    isShowLogo() {
      return this.countryIncludeLogo.includes(this.residentCountryName)
    },

    getMemberCardInformation() {
      const productId = this.$formData.product.productId
      const policyStartDate = this.$formData.policyDetails.policyStartDate
      const param = `productId=${productId}&productName=${this.productName}&countryName=${this.residentCountryName}&selectedDate=${policyStartDate}`
      baseApi
        .get(
          `api/getMemberCardInformation?${param}`,
        )
        .then((data) => {
          this.memberCard = { ...data }
        })
    },
  },
}
</script>
<style lang="scss">
.member-card {
  height: 204px;
  width: 323.5px;
  font-size: 10px;
  margin-top: 80px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 1);
  overflow-y: hidden;
  font-weight: 600;

  &-header {
    height: 35px;
    width: 100%;
  }

  &-content {
    height: calc(100% - 35px);
    width: 100%;
  }

  &-domain {
    font-weight: 700;
    color: #666565;
    display: flex;
    align-items: center;
  }
}
</style>
